import { portaalQueryOptions } from '@connected/portaal-sdk/queries/options';
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/customer/locations/$locationId/electrical/projects/')({
    component: RouteComponent,
    beforeLoad: async ({ params, context }) => {
        // Fetch the projects list to get the first project
        const queryClient = context.queryClient;
        const projects = await queryClient.fetchQuery(portaalQueryOptions.electrical.project.list({
            ObjectId: params.locationId,
        }));

        // If there are projects, redirect to the first one
        if (projects?.Projects && projects.Projects.length > 0) {
            const firstProject = projects.Projects[0];
            throw redirect({
                to: '/customer/locations/$locationId/electrical/projects/$projectId',
                params: {
                    locationId: params.locationId,
                    projectId: firstProject.ElectricalProjectId || '',
                },
            });
        }
        else {
            // Redirect back to location if no projects are found
            throw redirect({
                to: '/customer/locations/$locationId',
                params: {
                    locationId: params.locationId,
                },
                search: {
                    noProjects: true,
                },
            });
        }
    },
});

function RouteComponent() {
    return null;
}
